import { InputBase, NativeSelect, Tooltip, withStyles } from '@material-ui/core';
import MuiNativeSelect from '@mui/material/NativeSelect';
import React from 'react';
import Ratio from 'react-ratio';
import { MediaQuery, VerticalSp, VSLine } from '../Common';
import { InputGroup, InputPad } from '../auth/login';

import FormControl from '@material-ui/core/FormControl';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import images from '../../assets';
import { getCurrentLang } from '../../libs/lang';

export const CustomeSelect = withStyles({
  select: {
    fontFamily: 'NSCJKrR',
    fontSize: 16,
    height: 100,
    lineHeight: '1.5',
  },
})(NativeSelect);

const selectStyle = {
  height: '40px', // 드롭다운 메뉴의 높이를 조정합니다.
  lineHeight: '1.5',
};

export const MultiTitle = ({ maintitle, title, children }) => {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', height: '4.3vw', maxHeight: 78, minHeight: 40 }}>
        <MediaQuery min={900}>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 30, color: 'black' }}>
            {maintitle} 〉<span style={{ fontFamily: 'NSCJKrB' }}>{title}</span>
          </div>
        </MediaQuery>
        <MediaQuery max={899}>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 22, color: 'black' }}>
            {maintitle} 〉<span style={{ fontFamily: 'NSCJKrB' }}>{title}</span>
          </div>
        </MediaQuery>
        {children}
      </div>
    </>
  );
};

export const SearchSelect = ({ value, onChange, children, placeholder, style }) => {
  return (
    <FormControl style={{ minWidth: 80, marginTop: 0 }}>
      <MuiNativeSelect
        disableUnderline={true}
        value={value}
        defaultValue={placeholder}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <p style={{ fontFamily: 'NSCJKrR' }}>{placeholder}</p>;
          }
          return selected;
        }}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        style={{ position: '', selectStyle, fontFamily: 'NSCJKrR', height: 36 }}
      >
        {children}
      </MuiNativeSelect>
    </FormControl>
  );
};

export const SearchKeyword = ({ value, placeholder, onChange, onKeyPress }) => {
  return (
    <>
      <InputGroup style={{ borderBottomColor: '#a0a0a0', flex: 1, height: 40, minWidth: 120, maxWidth: 240 }}>
        <InputPad style={{ padding: '4px 4px' }}>
          <InputBase
            placeholder={placeholder}
            value={value}
            onChange={(event) => {
              onChange(event.target.value);
            }}
            style={{ width: '100%', fontSize: isMobile ? 14 : 16, fontFamily: 'NSCJKrR', color: 'black' }}
            onKeyPress={(event) => {
              onKeyPress(event);
            }}
          />
        </InputPad>
      </InputGroup>
    </>
  );
};

export const GoodHdCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  line-height: 14px;
  color: black;
  text-align: center;
  width: max-content;
  margin: auto;
`;

export const GoodCell = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: black;
  text-align: center;
`;

export const Memtype = ({ memtype = 'V' }) => {
  const { t } = useTranslation();
  return (
    <>
      {memtype === 'V' && (
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 14,
            padding: '0 10px',
            color: 'white',
            backgroundColor: '#fe8b07',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 24,
            borderRadius: 10,
            marginLeft: 10,
          }}
        >
          {t('vip_member')}
        </div>
      )}
      {memtype !== 'V' && (
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 14,
            color: 'white',
            backgroundColor: '#222222',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 80,
            height: 24,
            borderRadius: 10,
            marginLeft: 10,
          }}
        >
          {t('general_user')}
        </div>
      )}
    </>
  );
};

export const InputLbl = styled.div`
  position: absolute;
  left: 0px;
  top: -5px;
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: #999999;
`;

export const ImgUnit = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: black;
  width: 26px;
`;

export const InfBlockLbl = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: black;
  min-width: 160px;
`;

export const InfBlockRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const SpecRadio = styled.div`
  display: flex;
  align-items: center;
  font-family: NSCJKrR;
  font-size: 16px;
  color: black;
  cursor: pointer;
  width: max-content;
`;

export const InfToolTip = ({ title, children }) => {
  return (
    <Tooltip
      TransitionProps={{ style: { backgroundColor: '#ff8a06' } }}
      title={
        <div style={{ fontFamily: 'NSCJKrR', color: 'white', fontSize: 12, lineHeight: '12px', position: 'relative' }}>
          {title}
          <div
            style={{
              position: 'absolute',
              top: -9,
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img alt="" src={images.tooltip_arrow} style={{ transform: 'scaleY(-1)' }} />
          </div>
        </div>
      }
      placement="bottom"
    >
      {children}
    </Tooltip>
  );
};

export const MapImgItem = ({ title, value, onChange, mapimg, pngimg, zoomval }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      onClick={onChange}
    >
      <div style={{ backgroundImage: `url(${pngimg})`, backgroundSize: `${zoomval}%` }}>
        <Ratio
          ratio={1}
          style={{
            width: 134,
            backgroundImage: `url(${mapimg})`,
            border: '1px solid #dddddd',
            backgroundSize: 'cover',
          }}
        />
      </div>
      <div onClick={onChange} style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', lineHeight: '40px' }}>
        {title}
      </div>
      <img
        onClick={onChange}
        alt=""
        src={value ? images.icon_checked : images.icon_checknor}
        style={{ marginBottom: 30 }}
      />
    </div>
  );
};

export const LicenseTab = ({ title, destxt, value, onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        flex: 1,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '10px 10px',
        cursor: 'pointer',
        fontFamily: 'NSCJKrM',
        color: 'white',
        textAlign: 'center',
        backgroundColor: value ? '#ff8a06' : '#cccccc',
      }}
    >
      <div style={{ fontSize: 18 }}>{title}</div>
      <div style={{ fontSize: 14 }}>{destxt}</div>
      {value && (
        <div style={{ position: 'absolute', bottom: -9 }}>
          <img alt="" src={images.tooltip_arrow} />
        </div>
      )}
    </div>
  );
};

/**
 * 가격 정보를 표시하는 재사용 가능한 내부 컴포넌트
 * @param {object} props
 * @param {boolean} props.isMobile - 모바일 뷰 여부
 * @param {boolean} props.isRebate - 할인 여부
 * @param {object} props.priceInfo - 표시할 가격 정보 { currency, price, originalPrice }
 */
const PriceDisplay = ({ isMobile, isRebate, priceInfo }) => {
  // 가격 정보가 없으면 아무것도 렌더링하지 않음
  if (!priceInfo.price && !priceInfo.originalPrice) return null;

  // PC와 모바일 뷰에 따른 폰트 크기 동적 설정
  const styles = {
    price: { fontSize: isMobile ? 18 : 24 },
    originalPriceContainer: { fontSize: isMobile ? 14 : 16, color: '#999999', marginLeft: 4 },
    currency: { fontSize: isMobile ? 16 : 18, marginLeft: 4 },
  };

  return (
    <div
      style={{ fontFamily: 'NSCJKrB', color: '#222222', display: 'flex', alignItems: 'baseline', lineHeight: '26px' }}
    >
      <span style={styles.price}>
        {/* 할인 여부에 따라 할인가 또는 정가 표시 */}
        {isRebate ? priceInfo.price : priceInfo.originalPrice}
      </span>
      {/* 할인이 적용된 경우, 정가에 취소선을 그어 함께 표시 */}
      {isRebate && (
        <span style={styles.originalPriceContainer}>
          /<span style={{ textDecorationLine: 'line-through' }}>{priceInfo.originalPrice}</span>
        </span>
      )}
      <span style={styles.currency}>{priceInfo.currency}</span>
    </div>
  );
};

/**
 * 라이선스 유형별 가격 정보를 표시하는 리팩토링된 컴포넌트
 * @param {object} props - 컴포넌트 프로퍼티
 * @param {string} props.typeval - 라이선스 종류 (예: 'Basic')
 * @param {string} props.typedes - 라이선스 설명
 * @param {string} props.krwcost - 할인된 KRW(원화) 가격
 * @param {string} props.krwrebate - KRW(원화) 정가
 * @param {string} props.usdcost - 할인된 USD(달러) 가격
 * @param {string} props.usdrebate - USD(달러) 정가
 * @param {string} props.eurcost - 할인된 EUR(유로) 가격
 * @param {string} props.eurrebate - EUR(유로) 정가
 * @param {boolean} props.isRebate - 할인 적용 여부
 */
export const LicenseDesTag = (props) => {
  const { typeval, typedes, isRebate } = props;
  const currentLang = getCurrentLang();

  // 언어 설정에 따라 표시할 가격 데이터를 선택하는 로직
  const getPriceInfoForLang = () => {
    switch (currentLang) {
      case 'kr':
        return { currency: 'KRW', price: props.krwcost, originalPrice: props.krwrebate };
      case 'ur':
        return { currency: 'EUR', price: props.eurcost, originalPrice: props.eurrebate };
      default: // 'en'을 포함한 나머지 모든 언어
        return { currency: 'USD', price: props.usdcost, originalPrice: props.usdrebate };
    }
  };

  const priceInfo = getPriceInfoForLang();

  // PC와 모바일 뷰에서 공통으로 사용할 레이아웃 컴포넌트
  const LicenseInfoLayout = ({ isMobile = false }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {/* 왼쪽: 라이선스 정보 */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <div style={{ fontFamily: 'NSCJKrB', fontSize: isMobile ? 26 : 36, color: '#222222' }}>{typeval}</div>
        <div style={{ fontFamily: 'NSCJKrB', fontSize: isMobile ? 14 : 16, color: '#666666' }}>{typedes}</div>
      </div>
      <VSLine bgcolor="#dddddd" height={80} />
      {/* 오른쪽: 가격 정보 */}
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
        <PriceDisplay isMobile={isMobile} isRebate={isRebate} priceInfo={priceInfo} />
      </div>
    </div>
  );

  return (
    <div>
      <VerticalSp sp={'1.8vw'} style={{ maxHeight: 40, minHeight: 20 }} />

      {/* PC 뷰 */}
      <MediaQuery min={700}>
        <LicenseInfoLayout />
      </MediaQuery>

      {/* 모바일 뷰 */}
      <MediaQuery max={699}>
        <LicenseInfoLayout isMobile={true} />
      </MediaQuery>

      <VerticalSp sp={'1.8vw'} style={{ maxHeight: 40, minHeight: 20 }} />
    </div>
  );
};

export const VipTab = ({ title, value, onClick }) => {
  return (
    <>
      <MediaQuery min={600}>
        <div
          onClick={onClick}
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'NSCJKrM',
            fontSize: 18,
            color: 'white',
            cursor: 'pointer',
            position: 'relative',
            backgroundColor: value ? '#ff8a06' : '#cccccc',
            height: '2.7vw',
            maxHeight: 50,
            minHeight: 40,
          }}
        >
          {title}
          {value && (
            <div style={{ position: 'absolute', bottom: -9 }}>
              <img alt="" src={images.tooltip_arrow} />
            </div>
          )}
        </div>
      </MediaQuery>
      <MediaQuery max={599}>
        <div
          onClick={onClick}
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'NSCJKrM',
            fontSize: 16,
            color: 'white',
            cursor: 'pointer',
            position: 'relative',
            backgroundColor: value ? '#ff8a06' : '#cccccc',
            height: '2.7vw',
            maxHeight: 50,
            minHeight: 40,
          }}
        >
          {title}
          {value && (
            <div style={{ position: 'absolute', bottom: -9 }}>
              <img alt="" src={images.tooltip_arrow} />
            </div>
          )}
        </div>
      </MediaQuery>
    </>
  );
};

export const RebateChk = ({ value, onClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'flex-start',
          height: '2.2vw',
          maxHeight: 40,
          minHeight: 30,
        }}
      >
        <div
          onClick={onClick}
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            lineHeight: '16px',
            width: 'max-content',
          }}
        >
          <img alt="" src={value ? images.icon_checked : images.icon_checknor} style={{ marginRight: 10, }} /> 20%{' '}
            {t('discount')} 
        </div>
      </div>
      <span
        style={{fontSize: 'clamp(0.6875rem, 0.2969rem + 1.25vw, 1rem)', marginTop: 4,}}
      >({t('discount_detail')})</span>
    </>
  );
};
